import PostPageMetadataMobile from './post-page-metadata-mobile';
import PostPageMetadataDesktop from './post-page-metadata-desktop';
import forDevice from '../../hoc/for-device';

export default forDevice(PostPageMetadataMobile, PostPageMetadataDesktop);
